module.exports = __webpack_public_path__ + "img/hemline_kangaroo_pocket_position.690b5fbd.png";